<ng-container [formGroup]="warehouseDetailForm">
  <div class="card-body">
    <h2>Warehouse Detail</h2>
    <div class="form-row">
      <app-address [isRequired]="true"  (callback)="initChildForm($event.value)"  formControlName="main_address" [form]="form" [model]="model.model"></app-address>
    </div>
  </div>
</ng-container>
